import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useOcPolling } from "oc/hooks";

const GET_CALENDAR = gql`
  query calendar($startDate: Date!, $endDate: Date!) {
    calendar(startDate: $startDate, endDate: $endDate)
  }
`;

export const useOcCalendar = ({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}) => {
  const { data, loading, error } = useQuery(GET_CALENDAR, {
    skip: !startDate || !endDate,
    pollInterval: useOcPolling(1000 * 60),
    variables: { startDate, endDate },
  });

  return {
    data: data?.calendar,
    loading: loading,
    error: error,
  };
};

export default useOcCalendar;
